import { TestToProcess } from "../../components/OrderResults/CompleteModal"
import FormatDate from "../../formatters/FormatDate"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function CompleteTest(test: TestToProcess) {
  const requestBody: string = JSON.stringify({
    TestDetailID: test.TestDetailID,
    TestDetailClinicalID: test.TestDetailClinicalID,
    PersonID: test.PersonID,
    HireDate: FormatDate(test.HireDate),
    PoolID: test.PoolID,
    Images: test.Images
  })
  return ObservableFromFetch<string>("WorkforceTrack/CompleteTest", requestBody)
}

export function UnarchiveTest(test: TestToProcess) {
  const requestBody: string = JSON.stringify({
    TestDetailID: test.TestDetailID,
    TestDetailClinicalID: test.TestDetailClinicalID,
    PersonID: test.PersonID
  })
  return ObservableFromFetch<string>("WorkforceTrack/UnarchiveTest", requestBody)
}